import labels from './labels.json';
import common from './common.json';
import login from './login.json';
import newsletters from './newsletters.json';
import polls from './polls.json';
import students from './students.json';
import employees from './employees.json';
import orgs from './orgs.json';
import wiki from './wiki.json';
import settings from './settings.json';

const messages = {
  labels,
  common,
  login,
  newsletters,
  polls,
  students,
  employees,
  orgs,
  wiki,
  settings
};

export default messages;